<template>
  <div>
    监控记录管理
  </div>
</template>

<script>
export default {
  name: "record"
}
</script>

<style scoped>

</style>
